import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareCaptionsEnabledMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  captionsEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareCaptionsEnabledMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, captionsEnabled?: boolean | null } | { __typename?: 'CollectionShare', id: string, captionsEnabled?: boolean | null } | null } | null };


export const UpdateShareCaptionsEnabled = /*#__PURE__*/ gql`
    mutation UpdateShareCaptionsEnabled($shareId: ID!, $captionsEnabled: Boolean) {
  updateShare(
    input: {shareId: $shareId, settings: {captionsEnabled: $captionsEnabled}}
  ) {
    share {
      id
      captionsEnabled
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareCaptionsEnabledMutation, UpdateShareCaptionsEnabledMutationVariables>;

          

          export const useUpdateShareCaptionsEnabledMutation = (options?:MutationHookOptions<UpdateShareCaptionsEnabledMutation, UpdateShareCaptionsEnabledMutationVariables>) => useMutation(UpdateShareCaptionsEnabled, options);
          

          export type UpdateShareCaptionsEnabledMutationOptions = MutationHookOptions<UpdateShareCaptionsEnabledMutation, UpdateShareCaptionsEnabledMutationVariables>;

          

          export type UpdateShareCaptionsEnabledMutationResult = ReturnType<typeof useUpdateShareCaptionsEnabledMutation>[1];

          
